import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Three-language flat-key resource bundle for AutoDistrict.
// All keys used via t(...) across the codebase MUST be present in fr/en/nl.

const resources = {
  fr: {
    translation: {
      // ===== NAV =====
      "nav.home": "Accueil",
      "nav.inventory": "Inventaire",
      "nav.sell": "Revendez votre voiture",
      "nav.booking": "Prendre rendez-vous",
      "nav.contact": "Contact",

      // ===== HERO (Home) =====
      "hero.eyebrow": "Garage agréé — Wavre, Belgique",
      "hero.titleA": "Achetez votre prochaine voiture",
      "hero.titleB": "en toute confiance",
      "hero.slogan": "Driven by Quality",
      "hero.description": "Véhicules d'occasion contrôlés, garantie 1 an incluse, Car-Pass remis. Visite uniquement sur rendez-vous.",
      "hero.viewInventory": "Voir l'inventaire",
      "hero.bookAppointment": "Prendre rendez-vous",
      "hero.trust1": "Garantie 1 an",
      "hero.trust2": "Car-Pass",
      "hero.trust3": "Contrôle technique récent",
      "hero.latestArrivalBadge": "Dernier arrivage",
      "hero.fromMonth": "dès",
      "hero.perMonth": "/mois",

      // ===== SEARCH (Home + inventory) =====
      "search.makeModel": "Marque ou modèle (ex: Audi, BMW…)",
      "search.maxPrice": "Budget maximum (€)",
      "search.cta": "Rechercher",

      // ===== FEATURED INVENTORY (Home) =====
      "featured.eyebrow": "Notre inventaire",
      "featured.title": "Véhicules disponibles",
      "featured.seeAll": "Voir tout l'inventaire",
      "featured.empty": "Aucun véhicule disponible pour le moment. Revenez bientôt !",

      // ===== WHY US (Home) =====
      "why.eyebrow": "Nos engagements",
      "why.title2": "Pourquoi choisir AutoDistrict ?",
      "why.subtitle2": "Chaque véhicule est contrôlé, garanti et accompagné. Notre métier, c'est votre tranquillité.",
      "why.quality.title": "Qualité certifiée",
      "why.quality.desc": "Chaque véhicule subit un contrôle approfondi et est livré avec une garantie 1 an.",
      "why.carpass.title": "Car-Pass remis",
      "why.carpass.desc": "Historique kilométrique officiel pour chaque véhicule.",
      "why.maintenance.title": "Entretien rigoureux",
      "why.maintenance.desc": "Contrôle technique récent et entretiens vérifiés avant la livraison.",
      "why.financing.title": "Financement sur mesure",
      "why.financing.desc": "Solutions de financement étudiées avec notre partenaire agréé.",
      "why.assistance.title": "Assistance routière 1 an",
      "why.assistance.desc": "1 an d'assistance routière offerte dans toute l'Europe, incluse avec votre véhicule.",
      "why.insurance.title": "Assurance & immatriculation",
      "why.insurance.desc": "Prise en charge de l'assurance et de l'immatriculation via notre partenaire agréé.",

      // ===== TESTIMONIALS =====
      "testimonials.eyebrow": "Avis clients",
      "testimonials.title": "Ils nous ont fait confiance",
      "testimonials.subtitle": "Des acheteurs conquis par notre sélection contrôlée et notre accompagnement de A à Z.",
      "testimonials.basedOn": "basé sur {{count}} avis clients",
      "testimonials.t1": "Une BMW Série 1 impeccable, exactement conforme à l'annonce. Rendez-vous rapide, essai serein et livraison au top. Merci pour votre professionnalisme.",
      "testimonials.t2": "Accueil chaleureux et honnête pour l'achat de ma Classe E 220. Ils ont pris le temps d'expliquer chaque détail et de m'accompagner sur le financement. Voiture parfaite.",
      "testimonials.t3": "Golf VII 1.4 TSI très bien entretenue, Car-Pass à l'appui. Petit délai sur l'immatriculation mais globalement une très bonne expérience, je recommande.",
      "testimonials.leaveReview": "Laisser un avis",

      // ===== REVIEW FORM =====
      "reviewForm.eyebrow": "Votre avis",
      "reviewForm.title": "Laisser un avis",
      "reviewForm.rating": "Votre note",
      "reviewForm.name": "Nom",
      "reviewForm.namePh": "Marie D.",
      "reviewForm.city": "Ville",
      "reviewForm.cityPh": "Wavre",
      "reviewForm.vehicle": "Véhicule acheté (optionnel)",
      "reviewForm.vehiclePh": "BMW Série 1 118i",
      "reviewForm.comment": "Votre commentaire",
      "reviewForm.commentPh": "Racontez-nous votre expérience (min. 20 caractères)…",
      "reviewForm.email": "Email (privé, non publié)",
      "reviewForm.moderationNote": "Votre avis sera vérifié par notre équipe avant publication sur le site.",
      "reviewForm.submit": "Envoyer mon avis",
      "reviewForm.sending": "Envoi…",
      "reviewForm.close": "Fermer",
      "reviewForm.successTitle": "Merci pour votre avis !",
      "reviewForm.successBody": "Votre témoignage a été envoyé. Il sera publié après validation par notre équipe.",
      "reviewForm.errName": "Veuillez indiquer votre nom.",
      "reviewForm.errRating": "Veuillez sélectionner une note.",
      "reviewForm.errComment": "Votre commentaire doit contenir au moins 20 caractères.",
      "reviewForm.errGeneric": "Une erreur est survenue. Merci de réessayer.",

      // ===== SELL BANNER (Home) =====
      "sellbanner.eyebrow": "Vous vendez ?",
      "sellbanner.title": "Revendez votre voiture en toute sérénité",
      "sellbanner.desc": "Estimation gratuite, vente accompagnée, présentation professionnelle. Vous vous concentrez sur le résultat, nous gérons le reste.",
      "sellbanner.cta1": "Faites estimer votre véhicule",
      "sellbanner.cta2": "En savoir plus",

      // ===== VISIT (Home) =====
      "visit.eyebrow": "Sur rendez-vous",
      "visit.title": "Découvrez nos véhicules en personne",
      "visit.desc": "Notre garage à porte fermée vous accueille uniquement sur rendez-vous, pour un accompagnement personnalisé et sans pression commerciale.",
      "visit.book": "Prendre rendez-vous",
      "visit.contact": "Nous contacter",

      // ===== FOOTER =====
      "footer.description": "Votre garage de confiance pour l'achat et la revente de véhicules d'occasion en Belgique.",
      "footer.quickLinks": "Navigation",
      "footer.contact": "Contact",
      "footer.rights": "Tous droits réservés.",
      "footer.legalNotice": "Mentions légales",
      "footer.privacyPolicy": "Politique de confidentialité",
      "footer.trust.warranty": "Garantie 1 an incluse",
      "footer.trust.carpass": "Car-Pass remis",
      "footer.trust.tech": "Contrôle technique récent",
      "footer.trust.takeback": "Reprise possible",

      // ===== COOKIES =====
      "cookies.title": "Votre confidentialité",
      "cookies.body": "Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic et personnaliser le contenu. Vous pouvez accepter ou refuser. Vos préférences seront mémorisées.",
      "cookies.accept": "Accepter",
      "cookies.reject": "Refuser",
      "cookies.learnMore": "En savoir plus",

      // ===== NEWSLETTER =====
      "newsletter.label": "Newsletter",
      "newsletter.headerCta": "S'abonner à la newsletter",
      "newsletter.modalTitle": "Restez informé",
      "newsletter.intro": "Inscrivez-vous pour suivre nos nouvelles arrivées et offres exclusives.",
      "newsletter.firstName": "Prénom",
      "newsletter.email": "Votre e-mail",
      "newsletter.cta": "S'inscrire",
      "newsletter.sending": "Inscription…",
      "newsletter.success": "Inscription confirmée. Merci !",
      "newsletter.confirmed": "Merci ! Vous recevrez nos prochaines actualités.",
      "newsletter.error": "Inscription impossible. Vérifiez votre e-mail.",
      "newsletter.disclaimer": "En vous inscrivant, vous acceptez de recevoir nos communications. Désinscription possible à tout moment.",

      // ===== INVENTORY (list) =====
      "inventory.eyebrow": "Sélection contrôlée",
      "inventory.inventory": "Nos véhicules disponibles",
      "inventory.subtitle": "Chaque véhicule est contrôlé, certifié Car-Pass et livré avec une garantie 1 an incluse.",
      "inventory.resultCount": "véhicule(s)",
      "inventory.noVehicles": "Aucun véhicule ne correspond à vos critères.",
      "inventory.all": "Tous",
      "inventory.available": "Disponible",
      "inventory.reserved": "Réservé",
      "inventory.priceLowHigh": "Prix : croissant",
      "inventory.priceHighLow": "Prix : décroissant",
      "inventory.yearNew": "Année : récent → ancien",
      "inventory.yearOld": "Année : ancien → récent",
      "inventory.mileage": "Kilométrage croissant",

      // ===== FILTERS =====
      "filters.title": "Filtres",
      "filters.makeModel": "Marque ou modèle",
      "filters.maxPrice": "Budget max (€)",
      "filters.minYear": "Année min",
      "filters.maxKm": "Km max",
      "filters.fuel": "Carburant",
      "filters.status": "Statut",
      "filters.all": "Tous",
      "filters.reset": "Réinitialiser les filtres",

      // ===== COMMON / CARD / STATUSES =====
      "common.available": "Disponible",
      "common.reserved": "Réservé",
      "common.sold": "Vendu",
      "common.coming_soon": "Bientôt",
      "common.comingSoon": "Bientôt disponible",
      "common.featured": "À la une",
      "card.warranty": "Garantie 1 an",
      "card.details": "Détails",
      "card.fromPerMonth": "dès {{amount}} €/mois",
      "card.financingLabel": "Financement possible",
      "coming.headline": "Nouveau véhicule",
      "coming.subline": "En préparation pour vous",

      // ===== CAR DETAIL =====
      "car.notFound": "Véhicule introuvable",
      "car.backToInventory": "Retour à l'inventaire",
      "car.description": "Description",
      "car.features": "Équipements",
      "car.mileage": "Kilométrage",
      "car.fuel": "Carburant",
      "car.transmission": "Boîte",
      "car.color": "Couleur",
      "car.bookToView": "Prendre rendez-vous",
      "car.reserve": "Réserver ce véhicule",
      "car.contactInfo": "Nous contacter",
      "car.reserveSubject": "Réservation",
      "car.reserveMessage": "Bonjour, je souhaite réserver ce véhicule :",

      // ===== BOOKING =====
      "booking.title": "Visite",
      "booking.appointment": "Prendre rendez-vous",
      "booking.subtitle": "Visite uniquement sur rendez-vous. Nous revenons vers vous sous 24h.",
      "booking.fullName": "Nom complet",
      "booking.email": "Email",
      "booking.phone": "Téléphone",
      "booking.vehicle": "Véhicule",
      "booking.selectVehicle": "Sélectionnez un véhicule",
      "booking.preferredDate": "Date souhaitée",
      "booking.preferredTime": "Heure souhaitée",
      "booking.selectTime": "Sélectionnez une heure",
      "booking.pickDate": "Choisir une date",
      "booking.additionalInfo": "Informations complémentaires",
      "booking.message": "Précisions, questions…",
      "booking.note": "Note :",
      "booking.noteText": "Notre garage est uniquement accessible sur rendez-vous. Vous serez accueilli personnellement et sans pression commerciale.",
      "booking.submit": "Envoyer ma demande",
      "booking.submitting": "Envoi…",
      "booking.success": "Demande envoyée",
      "booking.successToast": "Demande envoyée avec succès !",
      "booking.successMessage": "Nous reviendrons vers vous sous 24h pour confirmer votre rendez-vous.",
      "booking.fillAll": "Veuillez remplir tous les champs requis",
      "booking.error": "Erreur lors de l'envoi. Veuillez réessayer.",

      // ===== CONTACT =====
      "contact.title": "Contact",
      "contact.touch": "Contactez-nous",
      "contact.subtitle": "Une question, une demande spécifique ? Notre équipe vous répond sous 24h ouvrées.",
      "contact.location": "Adresse",
      "contact.phone": "Téléphone",
      "contact.email": "Email",
      "contact.hours": "Horaires",
      "contact.appointmentOnly": "Uniquement sur rendez-vous",
      "contact.subject": "Sujet",
      "contact.howCanWeHelp": "Comment pouvons-nous vous aider ?",
      "contact.yourMessage": "Votre message…",
      "contact.sendMessage": "Envoyer un message",
      "contact.send": "Envoyer le message",
      "contact.sending": "Envoi…",
      "contact.success": "Message envoyé avec succès !",
      "contact.error": "Erreur lors de l'envoi.",
      "contact.fillAll": "Veuillez remplir tous les champs requis",

      // ===== LOCATION =====
      "location.title": "Notre adresse",
      "location.address": "Wavre, Belgique",
      "location.directions": "Itinéraire",

      // ===== SELL PAGE =====
      "sell.eyebrow": "Vente accompagnée premium",
      "sell.heroTitle": "Revendez votre voiture",
      "sell.heroTitleAccent": "avec exigence.",
      "sell.heroSubtitle": "Une sélection stricte. Une présentation professionnelle. Une vente sécurisée.",
      "sell.cta.primary": "Faites estimer votre véhicule",
      "sell.cta.secondary": "Découvrir le service",
      "sell.trust1": "Estimation gratuite",
      "sell.trust2": "Vente sécurisée",
      "sell.trust3": "Standards premium",
      "sell.intro.eyebrow": "Notre approche",
      "sell.intro.title": "Nous ne publions pas n'importe quel véhicule.",
      "sell.intro.p1": "Contrairement aux plateformes traditionnelles entre particuliers, chaque véhicule proposé par AutoDistrict est analysé, présenté et accompagné selon nos standards de qualité. Nous accompagnons les propriétaires sélectionnés dans la vente de leur véhicule lorsqu'il correspond à nos critères.",
      "sell.criteria.eyebrow": "Critères de sélection",
      "sell.criteria.title": "Chaque véhicule est sélectionné individuellement.",
      "sell.criteria.sub": "Une analyse préalable rigoureuse, parce que la qualité prime sur le volume.",
      "sell.criteria.history": "Historique clair",
      "sell.criteria.maintenance": "Entretien suivi",
      "sell.criteria.config": "Configuration attractive",
      "sell.criteria.condition": "État général cohérent",
      "sell.criteria.profile": "Véhicule premium, passion ou bien entretenu",
      "sell.presentation.eyebrow": "Présentation premium",
      "sell.presentation.title": "Une expérience proche des standards des concessions premium.",
      "sell.presentation.sub": "Chaque véhicule bénéficie d'une présentation professionnelle qui révèle son véritable potentiel.",
      "sell.offers.photos": "Photos premium",
      "sell.offers.video": "Vidéo de présentation",
      "sell.offers.immersive": "Captation immersive",
      "sell.offers.dayNight": "Présentation jour & nuit",
      "sell.offers.branding": "Branding AutoDistrict",
      "sell.offers.warranty": "Garantie 1 an incluse*",
      "sell.warranty.disclaimer": "* Garantie applicable selon le véhicule et son éligibilité. Conditions confirmées au cas par cas.",
      "sell.handle.title": "Nous gérons tout.",
      "sell.handle.sub": "Du premier contact à la poignée de main finale — vous vous concentrez sur le résultat, nous gérons le reste.",
      "sell.handle.listing": "Création de l'annonce",
      "sell.handle.visibility": "Visibilité en ligne",
      "sell.handle.requests": "Demandes acheteurs",
      "sell.handle.viewings": "Organisation des visites",
      "sell.handle.negotiation": "Négociations",
      "sell.handle.closing": "Accompagnement jusqu'à la vente",
      "sell.finalCta.eyebrow": "Prêt à commencer ?",
      "sell.finalCta.title": "Faites estimer votre véhicule gratuitement.",
      "sell.finalCta.desc": "Notre équipe revient vers vous sous 48h avec une analyse personnalisée.",

      // ===== ESTIMATE REQUEST =====
      "estimate.eyebrow": "Vente accompagnée premium",
      "estimate.title": "Faites estimer votre véhicule",
      "estimate.subtitle": "Remplissez le formulaire ci-dessous. Notre équipe analyse votre dossier et revient vers vous rapidement.",
      "estimate.optional": "optionnel",
      "estimate.section.contact": "Vos coordonnées",
      "estimate.section.vehicle": "Le véhicule",
      "estimate.section.photos": "Photos du véhicule",
      "estimate.section.extra": "Informations complémentaires",
      "estimate.field.firstName": "Prénom",
      "estimate.field.lastName": "Nom",
      "estimate.field.email": "E-mail",
      "estimate.field.phone": "Téléphone",
      "estimate.field.make": "Marque",
      "estimate.field.model": "Modèle",
      "estimate.field.year": "Année",
      "estimate.field.mileage": "Kilométrage (km)",
      "estimate.field.fuel": "Carburant",
      "estimate.field.transmission": "Boîte de vitesses",
      "estimate.field.desiredPrice": "Prix souhaité (€)",
      "estimate.field.ctech": "Contrôle technique valide",
      "estimate.field.carpass": "Car-Pass disponible",
      "estimate.photos.help": "Téléchargez idéalement une photo de chaque face. JPG/PNG, max 15 Mo par photo.",
      "estimate.photo.front": "Avant",
      "estimate.photo.back": "Arrière",
      "estimate.photo.side": "Côté",
      "estimate.photo.interior": "Intérieur",
      "estimate.extra.placeholder": "Historique d'entretien, équipements, particularités…",
      "estimate.disclaimer": "En envoyant cette demande, vous acceptez d'être recontacté par AutoDistrict concernant l'évaluation de votre véhicule. Vos données sont protégées — voir notre politique de confidentialité.",
      "estimate.submit": "Envoyer ma demande",
      "estimate.submitting": "Envoi en cours…",
      "estimate.success.eyebrow": "Demande envoyée",
      "estimate.success.title": "Merci, nous avons bien reçu votre dossier.",
      "estimate.success.body": "Notre équipe analyse votre demande et reviendra vers vous dans les plus brefs délais.",
      "estimate.success.back": "Retour à l'accueil",
      "estimate.error.notImage": "Le fichier doit être une image",
      "estimate.error.tooBig": "Image trop lourde (>15 Mo)",
      "estimate.error.upload": "Échec de l'upload",
      "estimate.error.submit": "Échec de l'envoi.",

      // ===== FINANCING =====
      "financing.eyebrow": "Financement",
      "financing.title": "Simulez votre mensualité",
      "financing.subtitle": "Prêt auto de 2 500 € à 50 000 €, TAEG 5,59 % → 8,99 %, jusqu'à 84 mois.",
      "financing.apr": "TAEG",
      "financing.aprRange": "TAEG 5,59 % → 8,99 %",
      "financing.duration": "Durée",
      "financing.months": "mois",
      "financing.years": "ans",
      "financing.loanAmount": "Montant emprunté",
      "financing.monthlyPayment": "Mensualité estimée",
      "financing.monthlyRange": "Mensualité (min. → max.)",
      "financing.totalRepayment": "Total à rembourser",
      "financing.totalRange": "Total (min. → max.)",
      "financing.cost": "Coût du crédit",
      "financing.from": "dès",
      "financing.perMonth": "par mois",
      "financing.perMonthShort": "/ mois",
      "financing.simulate": "Simuler mon financement",
      "financing.requestQuote": "Demander une offre",
      "financing.requestCta": "Demander mon offre de financement",
      "financing.requestSubject": "Demande de financement",
      "financing.requestBody": "Bonjour,\n\nJe souhaite recevoir une offre de financement pour le véhicule suivant :\n{{car}}\n\nSimulation :\n• Montant à financer : {{amount}} €\n• Durée souhaitée : {{months}} mois\n• Mensualité indicative : {{monthlyMin}} € → {{monthlyMax}} €\n\nMerci de me recontacter pour compléter mon dossier.",
      "financing.teaser.tooltip": "Simulation indicative — TAEG min. 5,59 %, sur 60 mois, sans acompte.",
      "financing.warning": "Attention, emprunter de l'argent coûte aussi de l'argent.",
      "financing.notEligibleTitle": "Financement non disponible pour ce véhicule",
      "financing.notEligibleAgeDesc": "Notre solution de financement est réservée aux véhicules de moins de 5 ans. Contactez-nous pour d'autres options de financement.",
      "financing.notEligiblePriceDesc": "Notre solution de financement couvre les montants entre 2 500 € et 50 000 €. Contactez-nous pour des solutions adaptées à votre budget.",
      "financing.disclaimer": "Simulation indicative fournie par AutoDistrict. Sous réserve d'acceptation de votre dossier par notre partenaire financier agréé. Le TAEG définitif dépend de votre profil emprunteur, du montant et de la durée. Prêt réservé aux véhicules d'occasion ≤ 5 ans, achetés chez un professionnel.",

      // ===== SEO =====
      "seo.home.title": "AutoDistrict — Voitures d'occasion garanties à Wavre, Belgique",
      "seo.home.desc": "Garage à porte fermée à Wavre. Voitures d'occasion contrôlées, Car-Pass, garantie 1 an incluse. Achat, revente accompagnée et financement sur mesure.",
      "seo.inventory.title": "Inventaire — Voitures d'occasion garanties",
      "seo.inventory.desc": "Découvrez notre sélection de voitures d'occasion contrôlées et garanties 1 an. Audi, BMW, Volkswagen et plus. Car-Pass remis pour chaque véhicule.",
      "seo.sell.title": "Revendez votre voiture en toute sérénité",
      "seo.sell.desc": "Service de vente accompagnée à Wavre : estimation gratuite, présentation pro, vente sécurisée. Votre voiture entre de bonnes mains.",
      "seo.estimate.title": "Faites estimer votre véhicule gratuitement",
      "seo.estimate.desc": "Formulaire d'estimation rapide pour votre véhicule. Réponse personnalisée sous 48h. Service gratuit et sans engagement.",
      "seo.booking.title": "Prendre rendez-vous — Visite sur rendez-vous",
      "seo.booking.desc": "Réservez un créneau pour découvrir un véhicule chez AutoDistrict. Visite uniquement sur rendez-vous, accompagnement personnalisé.",
      "seo.contact.title": "Contact — AutoDistrict Wavre",
      "seo.contact.desc": "Contactez notre équipe par téléphone, email ou via le formulaire. Réponse sous 24h ouvrées. Garage à Wavre, Belgique.",
      "seo.legal.title": "Mentions légales",
      "seo.legal.desc": "Mentions légales de la société SHLI SRL — AutoDistrict. Informations légales sur l'éditeur du site et l'hébergeur.",
      "seo.privacy.title": "Politique de confidentialité",
      "seo.privacy.desc": "Politique de protection de vos données personnelles conforme au RGPD. Quelles données nous collectons et comment elles sont utilisées.",
    },
  },

  en: {
    translation: {
      // ===== NAV =====
      "nav.home": "Home",
      "nav.inventory": "Inventory",
      "nav.sell": "Sell your car",
      "nav.booking": "Book an appointment",
      "nav.contact": "Contact",

      // ===== HERO =====
      "hero.eyebrow": "Approved garage — Wavre, Belgium",
      "hero.titleA": "Buy your next car",
      "hero.titleB": "with total peace of mind",
      "hero.slogan": "Driven by Quality",
      "hero.description": "Inspected used vehicles, 1-year warranty included, Car-Pass provided. Visits by appointment only.",
      "hero.viewInventory": "View inventory",
      "hero.bookAppointment": "Book appointment",
      "hero.trust1": "1-year warranty",
      "hero.trust2": "Car-Pass",
      "hero.trust3": "Recent inspection",
      "hero.latestArrivalBadge": "Latest arrival",
      "hero.fromMonth": "from",
      "hero.perMonth": "/month",

      // ===== SEARCH =====
      "search.makeModel": "Make or model (e.g. Audi, BMW…)",
      "search.maxPrice": "Maximum budget (€)",
      "search.cta": "Search",

      // ===== FEATURED =====
      "featured.eyebrow": "Our inventory",
      "featured.title": "Available vehicles",
      "featured.seeAll": "See full inventory",
      "featured.empty": "No vehicles available at the moment. Check back soon!",

      // ===== WHY US =====
      "why.eyebrow": "Our commitments",
      "why.title2": "Why choose AutoDistrict?",
      "why.subtitle2": "Every vehicle is inspected, warrantied and supported. Our business is your peace of mind.",
      "why.quality.title": "Certified quality",
      "why.quality.desc": "Every vehicle undergoes a thorough inspection and is delivered with a 1-year warranty.",
      "why.carpass.title": "Car-Pass provided",
      "why.carpass.desc": "Official mileage history for every vehicle.",
      "why.maintenance.title": "Rigorous maintenance",
      "why.maintenance.desc": "Recent inspection and verified maintenance before delivery.",
      "why.financing.title": "Tailored financing",
      "why.financing.desc": "Financing solutions developed with our approved partner.",
      "why.assistance.title": "1-year roadside assistance",
      "why.assistance.desc": "One year of roadside assistance included across Europe with every vehicle.",
      "why.insurance.title": "Insurance & registration",
      "why.insurance.desc": "Insurance and registration handled through our approved partner.",

      // ===== TESTIMONIALS =====
      "testimonials.eyebrow": "Customer reviews",
      "testimonials.title": "They trusted us",
      "testimonials.subtitle": "Buyers won over by our inspected selection and end-to-end support.",
      "testimonials.basedOn": "based on {{count}} customer reviews",
      "testimonials.t1": "A spotless BMW 1 Series, exactly as advertised. Quick appointment, relaxed test drive and flawless delivery. Thank you for your professionalism.",
      "testimonials.t2": "Warm and honest welcome for the purchase of my E 220. They took the time to explain every detail and helped me with financing. Perfect car.",
      "testimonials.t3": "Very well maintained Golf VII 1.4 TSI, Car-Pass to back it up. Small delay on the registration but overall a very good experience, highly recommended.",
      "testimonials.leaveReview": "Leave a review",

      // ===== REVIEW FORM =====
      "reviewForm.eyebrow": "Your review",
      "reviewForm.title": "Leave a review",
      "reviewForm.rating": "Your rating",
      "reviewForm.name": "Name",
      "reviewForm.namePh": "Mary D.",
      "reviewForm.city": "City",
      "reviewForm.cityPh": "Wavre",
      "reviewForm.vehicle": "Vehicle purchased (optional)",
      "reviewForm.vehiclePh": "BMW 1 Series 118i",
      "reviewForm.comment": "Your comment",
      "reviewForm.commentPh": "Tell us about your experience (min. 20 characters)…",
      "reviewForm.email": "Email (private, not published)",
      "reviewForm.moderationNote": "Your review will be verified by our team before publication.",
      "reviewForm.submit": "Send my review",
      "reviewForm.sending": "Sending…",
      "reviewForm.close": "Close",
      "reviewForm.successTitle": "Thanks for your review!",
      "reviewForm.successBody": "Your testimonial has been sent. It will be published after verification by our team.",
      "reviewForm.errName": "Please provide your name.",
      "reviewForm.errRating": "Please select a rating.",
      "reviewForm.errComment": "Your comment must be at least 20 characters long.",
      "reviewForm.errGeneric": "Something went wrong. Please try again.",

      // ===== SELL BANNER =====
      "sellbanner.eyebrow": "Selling your car?",
      "sellbanner.title": "Sell your car with complete peace of mind",
      "sellbanner.desc": "Free valuation, assisted sale, professional presentation. You focus on the outcome, we handle the rest.",
      "sellbanner.cta1": "Get your vehicle valued",
      "sellbanner.cta2": "Learn more",

      // ===== VISIT =====
      "visit.eyebrow": "By appointment",
      "visit.title": "Discover our vehicles in person",
      "visit.desc": "Our closed-door garage welcomes you by appointment only, for personal service without sales pressure.",
      "visit.book": "Book an appointment",
      "visit.contact": "Contact us",

      // ===== FOOTER =====
      "footer.description": "Your trusted garage for buying and selling used vehicles in Belgium.",
      "footer.quickLinks": "Navigation",
      "footer.contact": "Contact",
      "footer.rights": "All rights reserved.",
      "footer.legalNotice": "Legal Notice",
      "footer.privacyPolicy": "Privacy Policy",
      "footer.trust.warranty": "1-year warranty included",
      "footer.trust.carpass": "Car-Pass provided",
      "footer.trust.tech": "Recent technical inspection",
      "footer.trust.takeback": "Trade-in available",

      // ===== COOKIES =====
      "cookies.title": "Your privacy",
      "cookies.body": "We use cookies to improve your experience, analyse traffic and personalise content. You can accept or decline. Your preferences will be saved.",
      "cookies.accept": "Accept",
      "cookies.reject": "Decline",
      "cookies.learnMore": "Learn more",

      // ===== NEWSLETTER =====
      "newsletter.label": "Newsletter",
      "newsletter.headerCta": "Subscribe to the newsletter",
      "newsletter.modalTitle": "Stay informed",
      "newsletter.intro": "Sign up to follow our new arrivals and exclusive offers.",
      "newsletter.firstName": "First name",
      "newsletter.email": "Your email",
      "newsletter.cta": "Subscribe",
      "newsletter.sending": "Subscribing…",
      "newsletter.success": "Subscription confirmed. Thank you!",
      "newsletter.confirmed": "Thank you! You will receive our next updates.",
      "newsletter.error": "Subscription failed. Please check your email.",
      "newsletter.disclaimer": "By subscribing, you agree to receive our communications. You can unsubscribe at any time.",

      // ===== INVENTORY =====
      "inventory.eyebrow": "Inspected selection",
      "inventory.inventory": "Our available vehicles",
      "inventory.subtitle": "Every vehicle is inspected, Car-Pass certified and delivered with a 1-year warranty included.",
      "inventory.resultCount": "vehicle(s)",
      "inventory.noVehicles": "No vehicles match your criteria.",
      "inventory.all": "All",
      "inventory.available": "Available",
      "inventory.reserved": "Reserved",
      "inventory.priceLowHigh": "Price: low to high",
      "inventory.priceHighLow": "Price: high to low",
      "inventory.yearNew": "Year: newest first",
      "inventory.yearOld": "Year: oldest first",
      "inventory.mileage": "Mileage ascending",

      // ===== FILTERS =====
      "filters.title": "Filters",
      "filters.makeModel": "Make or model",
      "filters.maxPrice": "Max budget (€)",
      "filters.minYear": "Min year",
      "filters.maxKm": "Max km",
      "filters.fuel": "Fuel",
      "filters.status": "Status",
      "filters.all": "All",
      "filters.reset": "Reset filters",

      // ===== COMMON / CARD =====
      "common.available": "Available",
      "common.reserved": "Reserved",
      "common.sold": "Sold",
      "common.coming_soon": "Coming soon",
      "common.comingSoon": "Coming soon",
      "common.featured": "Featured",
      "card.warranty": "1-year warranty",
      "card.details": "Details",
      "card.fromPerMonth": "from €{{amount}}/month",
      "card.financingLabel": "Financing available",
      "coming.headline": "New vehicle",
      "coming.subline": "Being prepared for you",

      // ===== CAR DETAIL =====
      "car.notFound": "Vehicle not found",
      "car.backToInventory": "Back to inventory",
      "car.description": "Description",
      "car.features": "Features",
      "car.mileage": "Mileage",
      "car.fuel": "Fuel",
      "car.transmission": "Transmission",
      "car.color": "Colour",
      "car.bookToView": "Book an appointment",
      "car.reserve": "Reserve this vehicle",
      "car.contactInfo": "Contact us",
      "car.reserveSubject": "Reservation",
      "car.reserveMessage": "Hello, I would like to reserve this vehicle:",

      // ===== BOOKING =====
      "booking.title": "Visit",
      "booking.appointment": "Book an appointment",
      "booking.subtitle": "Visits by appointment only. We get back to you within 24h.",
      "booking.fullName": "Full name",
      "booking.email": "Email",
      "booking.phone": "Phone",
      "booking.vehicle": "Vehicle",
      "booking.selectVehicle": "Select a vehicle",
      "booking.preferredDate": "Preferred date",
      "booking.preferredTime": "Preferred time",
      "booking.selectTime": "Select a time",
      "booking.pickDate": "Pick a date",
      "booking.additionalInfo": "Additional information",
      "booking.message": "Details, questions…",
      "booking.note": "Note:",
      "booking.noteText": "Our garage is accessible by appointment only. You will be welcomed personally and without sales pressure.",
      "booking.submit": "Send my request",
      "booking.submitting": "Sending…",
      "booking.success": "Request sent",
      "booking.successToast": "Request sent successfully!",
      "booking.successMessage": "We will get back to you within 24h to confirm your appointment.",
      "booking.fillAll": "Please fill in all required fields",
      "booking.error": "Failed to send. Please try again.",

      // ===== CONTACT =====
      "contact.title": "Contact",
      "contact.touch": "Get in touch",
      "contact.subtitle": "A question, a specific request? Our team responds within 24 business hours.",
      "contact.location": "Address",
      "contact.phone": "Phone",
      "contact.email": "Email",
      "contact.hours": "Opening hours",
      "contact.appointmentOnly": "By appointment only",
      "contact.subject": "Subject",
      "contact.howCanWeHelp": "How can we help you?",
      "contact.yourMessage": "Your message…",
      "contact.sendMessage": "Send a message",
      "contact.send": "Send the message",
      "contact.sending": "Sending…",
      "contact.success": "Message sent successfully!",
      "contact.error": "Failed to send.",
      "contact.fillAll": "Please fill in all required fields",

      // ===== LOCATION =====
      "location.title": "Our address",
      "location.address": "Wavre, Belgium",
      "location.directions": "Directions",

      // ===== SELL PAGE =====
      "sell.eyebrow": "Premium assisted sale",
      "sell.heroTitle": "Sell your car",
      "sell.heroTitleAccent": "with high standards.",
      "sell.heroSubtitle": "Strict selection. Professional presentation. Secure sale.",
      "sell.cta.primary": "Get your vehicle valued",
      "sell.cta.secondary": "Discover the service",
      "sell.trust1": "Free valuation",
      "sell.trust2": "Secure sale",
      "sell.trust3": "Premium standards",
      "sell.intro.eyebrow": "Our approach",
      "sell.intro.title": "We do not list just any vehicle.",
      "sell.intro.p1": "Unlike traditional peer-to-peer platforms, every vehicle proposed by AutoDistrict is analysed, presented and supported according to our quality standards. We support selected owners in selling their vehicle when it matches our criteria.",
      "sell.criteria.eyebrow": "Selection criteria",
      "sell.criteria.title": "Every vehicle is selected individually.",
      "sell.criteria.sub": "A rigorous prior analysis, because quality matters more than volume.",
      "sell.criteria.history": "Clear history",
      "sell.criteria.maintenance": "Documented maintenance",
      "sell.criteria.config": "Attractive configuration",
      "sell.criteria.condition": "Consistent overall condition",
      "sell.criteria.profile": "Premium, passion or well-maintained vehicle",
      "sell.presentation.eyebrow": "Premium presentation",
      "sell.presentation.title": "An experience close to premium dealership standards.",
      "sell.presentation.sub": "Each vehicle benefits from professional presentation that reveals its true potential.",
      "sell.offers.photos": "Premium photos",
      "sell.offers.video": "Presentation video",
      "sell.offers.immersive": "Immersive capture",
      "sell.offers.dayNight": "Day & night presentation",
      "sell.offers.branding": "AutoDistrict branding",
      "sell.offers.warranty": "1-year warranty included*",
      "sell.warranty.disclaimer": "* Warranty applicable depending on the vehicle and its eligibility. Conditions confirmed case by case.",
      "sell.handle.title": "We handle everything.",
      "sell.handle.sub": "From first contact to final handshake — you focus on the outcome, we handle the rest.",
      "sell.handle.listing": "Listing creation",
      "sell.handle.visibility": "Online visibility",
      "sell.handle.requests": "Buyer requests",
      "sell.handle.viewings": "Viewing scheduling",
      "sell.handle.negotiation": "Negotiations",
      "sell.handle.closing": "Support all the way to sale",
      "sell.finalCta.eyebrow": "Ready to start?",
      "sell.finalCta.title": "Get your vehicle valued for free.",
      "sell.finalCta.desc": "Our team will get back to you within 48h with a personalised analysis.",

      // ===== ESTIMATE =====
      "estimate.eyebrow": "Premium assisted sale",
      "estimate.title": "Get your vehicle valued",
      "estimate.subtitle": "Fill in the form below. Our team analyses your file and gets back to you promptly.",
      "estimate.optional": "optional",
      "estimate.section.contact": "Your contact details",
      "estimate.section.vehicle": "The vehicle",
      "estimate.section.photos": "Vehicle photos",
      "estimate.section.extra": "Additional information",
      "estimate.field.firstName": "First name",
      "estimate.field.lastName": "Last name",
      "estimate.field.email": "Email",
      "estimate.field.phone": "Phone",
      "estimate.field.make": "Make",
      "estimate.field.model": "Model",
      "estimate.field.year": "Year",
      "estimate.field.mileage": "Mileage (km)",
      "estimate.field.fuel": "Fuel",
      "estimate.field.transmission": "Transmission",
      "estimate.field.desiredPrice": "Desired price (€)",
      "estimate.field.ctech": "Valid technical inspection",
      "estimate.field.carpass": "Car-Pass available",
      "estimate.photos.help": "Ideally upload one photo of each side. JPG/PNG, max 15 MB per photo.",
      "estimate.photo.front": "Front",
      "estimate.photo.back": "Rear",
      "estimate.photo.side": "Side",
      "estimate.photo.interior": "Interior",
      "estimate.extra.placeholder": "Maintenance history, equipment, specifics…",
      "estimate.disclaimer": "By sending this request, you agree to be contacted by AutoDistrict regarding the valuation of your vehicle. Your data is protected — see our privacy policy.",
      "estimate.submit": "Send my request",
      "estimate.submitting": "Sending…",
      "estimate.success.eyebrow": "Request sent",
      "estimate.success.title": "Thank you, your file has been received.",
      "estimate.success.body": "Our team is reviewing your request and will get back to you as soon as possible.",
      "estimate.success.back": "Back to home",
      "estimate.error.notImage": "The file must be an image",
      "estimate.error.tooBig": "Image too large (>15 MB)",
      "estimate.error.upload": "Upload failed",
      "estimate.error.submit": "Sending failed.",

      // ===== FINANCING =====
      "financing.eyebrow": "Financing",
      "financing.title": "Simulate your monthly payment",
      "financing.subtitle": "Car loan from €2,500 to €50,000, APR 5.59% → 8.99%, up to 84 months.",
      "financing.apr": "APR",
      "financing.aprRange": "APR 5.59% → 8.99%",
      "financing.duration": "Term",
      "financing.months": "months",
      "financing.years": "years",
      "financing.loanAmount": "Loan amount",
      "financing.monthlyPayment": "Estimated monthly payment",
      "financing.monthlyRange": "Monthly payment (min → max)",
      "financing.totalRepayment": "Total to repay",
      "financing.totalRange": "Total (min → max)",
      "financing.cost": "Credit cost",
      "financing.from": "from",
      "financing.perMonth": "per month",
      "financing.perMonthShort": "/ month",
      "financing.simulate": "Simulate my financing",
      "financing.requestQuote": "Request an offer",
      "financing.requestCta": "Request my financing offer",
      "financing.requestSubject": "Financing request",
      "financing.requestBody": "Hello,\n\nI would like to receive a financing offer for the following vehicle:\n{{car}}\n\nSimulation:\n• Amount to finance: €{{amount}}\n• Desired term: {{months}} months\n• Indicative monthly payment: €{{monthlyMin}} → €{{monthlyMax}}\n\nPlease get back to me to complete my application.",
      "financing.teaser.tooltip": "Indicative simulation — min APR 5.59%, over 60 months, no down payment.",
      "financing.warning": "Warning, borrowing money also costs money.",
      "financing.notEligibleTitle": "Financing unavailable for this vehicle",
      "financing.notEligibleAgeDesc": "Our financing solution is reserved for vehicles under 5 years old. Contact us for alternative financing options.",
      "financing.notEligiblePriceDesc": "Our financing solution covers amounts from €2,500 to €50,000. Contact us for solutions tailored to your budget.",
      "financing.disclaimer": "Indicative simulation by AutoDistrict. Subject to acceptance of your application by our approved financial partner. The final APR depends on your borrower profile, amount and term. Loans reserved for second-hand vehicles ≤ 5 years old, purchased from a professional.",

      // ===== SEO =====
      "seo.home.title": "AutoDistrict — Inspected used cars in Wavre, Belgium",
      "seo.home.desc": "Closed-door garage in Wavre. Inspected used cars, Car-Pass, 1-year warranty included. Buying, assisted resale and tailored financing.",
      "seo.inventory.title": "Inventory — Warrantied used cars",
      "seo.inventory.desc": "Browse our selection of inspected used cars with 1-year warranty. Audi, BMW, Volkswagen and more. Car-Pass provided for every vehicle.",
      "seo.sell.title": "Sell your car with complete peace of mind",
      "seo.sell.desc": "Assisted sale service in Wavre: free valuation, pro presentation, secure sale. Your car in good hands.",
      "seo.estimate.title": "Get your vehicle valued for free",
      "seo.estimate.desc": "Quick valuation form for your vehicle. Personalised response within 48h. Free service with no obligation.",
      "seo.booking.title": "Book an appointment — Visit by appointment",
      "seo.booking.desc": "Book a slot to discover a vehicle at AutoDistrict. Visit by appointment only, personal service.",
      "seo.contact.title": "Contact — AutoDistrict Wavre",
      "seo.contact.desc": "Contact our team by phone, email or via the form. Reply within 24 business hours. Garage in Wavre, Belgium.",
      "seo.legal.title": "Legal Notice",
      "seo.legal.desc": "Legal notice of SHLI SRL — AutoDistrict. Legal information about the publisher of the site and the hosting provider.",
      "seo.privacy.title": "Privacy Policy",
      "seo.privacy.desc": "GDPR-compliant policy on protecting your personal data. What data we collect and how we use it.",
    },
  },

  nl: {
    translation: {
      // ===== NAV =====
      "nav.home": "Home",
      "nav.inventory": "Aanbod",
      "nav.sell": "Verkoop uw wagen",
      "nav.booking": "Afspraak maken",
      "nav.contact": "Contact",

      // ===== HERO =====
      "hero.eyebrow": "Erkende garage — Waver, België",
      "hero.titleA": "Koop uw volgende wagen",
      "hero.titleB": "in alle vertrouwen",
      "hero.slogan": "Driven by Quality",
      "hero.description": "Gecontroleerde tweedehandswagens, 1 jaar garantie inbegrepen, Car-Pass overhandigd. Bezoek uitsluitend op afspraak.",
      "hero.viewInventory": "Bekijk het aanbod",
      "hero.bookAppointment": "Afspraak maken",
      "hero.trust1": "1 jaar garantie",
      "hero.trust2": "Car-Pass",
      "hero.trust3": "Recente keuring",
      "hero.latestArrivalBadge": "Nieuwste aanwinst",
      "hero.fromMonth": "vanaf",
      "hero.perMonth": "/maand",

      // ===== SEARCH =====
      "search.makeModel": "Merk of model (bv. Audi, BMW…)",
      "search.maxPrice": "Maximum budget (€)",
      "search.cta": "Zoeken",

      // ===== FEATURED =====
      "featured.eyebrow": "Ons aanbod",
      "featured.title": "Beschikbare wagens",
      "featured.seeAll": "Bekijk volledig aanbod",
      "featured.empty": "Momenteel geen wagens beschikbaar. Kom snel terug!",

      // ===== WHY US =====
      "why.eyebrow": "Onze beloftes",
      "why.title2": "Waarom AutoDistrict kiezen?",
      "why.subtitle2": "Elke wagen wordt gecontroleerd, voorzien van garantie en begeleid. Onze vakkennis, uw gemoedsrust.",
      "why.quality.title": "Gecertificeerde kwaliteit",
      "why.quality.desc": "Elke wagen wordt grondig gecontroleerd en geleverd met 1 jaar garantie.",
      "why.carpass.title": "Car-Pass overhandigd",
      "why.carpass.desc": "Officiële kilometerstand-historiek voor elke wagen.",
      "why.maintenance.title": "Strikt onderhoud",
      "why.maintenance.desc": "Recente keuring en geverifieerde onderhoudsbeurten vóór de levering.",
      "why.financing.title": "Financiering op maat",
      "why.financing.desc": "Financieringsoplossingen uitgewerkt met onze erkende partner.",
      "why.assistance.title": "1 jaar pechverhelping",
      "why.assistance.desc": "1 jaar pechverhelping in heel Europa inbegrepen bij elke wagen.",
      "why.insurance.title": "Verzekering & inschrijving",
      "why.insurance.desc": "Verzekering en inschrijving via onze erkende partner geregeld.",

      // ===== TESTIMONIALS =====
      "testimonials.eyebrow": "Klantbeoordelingen",
      "testimonials.title": "Zij vertrouwden ons",
      "testimonials.subtitle": "Kopers overtuigd door onze gecontroleerde selectie en volledige begeleiding.",
      "testimonials.basedOn": "gebaseerd op {{count}} klantbeoordelingen",
      "testimonials.t1": "Een onberispelijke BMW 1-reeks, exact zoals in de advertentie. Snel afspraak, ontspannen proefrit en vlekkeloze levering. Bedankt voor jullie professionalisme.",
      "testimonials.t2": "Warme en eerlijke ontvangst voor de aankoop van mijn E 220. Ze namen de tijd om elk detail uit te leggen en hielpen mij met de financiering. Perfecte wagen.",
      "testimonials.t3": "Zeer goed onderhouden Golf VII 1.4 TSI, met Car-Pass ter staving. Kleine vertraging bij de inschrijving maar globaal een zeer goede ervaring, sterk aanbevolen.",
      "testimonials.leaveReview": "Beoordeling achterlaten",

      // ===== REVIEW FORM =====
      "reviewForm.eyebrow": "Uw beoordeling",
      "reviewForm.title": "Beoordeling achterlaten",
      "reviewForm.rating": "Uw score",
      "reviewForm.name": "Naam",
      "reviewForm.namePh": "Marie D.",
      "reviewForm.city": "Stad",
      "reviewForm.cityPh": "Waver",
      "reviewForm.vehicle": "Aangekochte wagen (optioneel)",
      "reviewForm.vehiclePh": "BMW 1-reeks 118i",
      "reviewForm.comment": "Uw commentaar",
      "reviewForm.commentPh": "Vertel ons over uw ervaring (min. 20 tekens)…",
      "reviewForm.email": "E-mail (privé, niet gepubliceerd)",
      "reviewForm.moderationNote": "Uw beoordeling wordt door ons team gecontroleerd voordat ze op de site verschijnt.",
      "reviewForm.submit": "Mijn beoordeling versturen",
      "reviewForm.sending": "Verzenden…",
      "reviewForm.close": "Sluiten",
      "reviewForm.successTitle": "Bedankt voor uw beoordeling!",
      "reviewForm.successBody": "Uw getuigenis is verzonden. Ze wordt gepubliceerd na validatie door ons team.",
      "reviewForm.errName": "Geef uw naam op.",
      "reviewForm.errRating": "Kies een score.",
      "reviewForm.errComment": "Uw commentaar moet minstens 20 tekens bevatten.",
      "reviewForm.errGeneric": "Er is een fout opgetreden. Probeer opnieuw.",

      // ===== SELL BANNER =====
      "sellbanner.eyebrow": "Wilt u verkopen?",
      "sellbanner.title": "Verkoop uw wagen in alle rust",
      "sellbanner.desc": "Gratis schatting, begeleide verkoop, professionele presentatie. U focust op het resultaat, wij regelen de rest.",
      "sellbanner.cta1": "Laat uw wagen schatten",
      "sellbanner.cta2": "Meer weten",

      // ===== VISIT =====
      "visit.eyebrow": "Op afspraak",
      "visit.title": "Ontdek onze wagens in persoon",
      "visit.desc": "Onze gesloten garage ontvangt u uitsluitend op afspraak, voor een persoonlijke begeleiding zonder verkoopdruk.",
      "visit.book": "Afspraak maken",
      "visit.contact": "Contacteer ons",

      // ===== FOOTER =====
      "footer.description": "Uw vertrouwde garage voor de aankoop en verkoop van tweedehandswagens in België.",
      "footer.quickLinks": "Navigatie",
      "footer.contact": "Contact",
      "footer.rights": "Alle rechten voorbehouden.",
      "footer.legalNotice": "Wettelijke vermeldingen",
      "footer.privacyPolicy": "Privacybeleid",
      "footer.trust.warranty": "1 jaar garantie inbegrepen",
      "footer.trust.carpass": "Car-Pass overhandigd",
      "footer.trust.tech": "Recente technische keuring",
      "footer.trust.takeback": "Inruil mogelijk",

      // ===== COOKIES =====
      "cookies.title": "Uw privacy",
      "cookies.body": "Wij gebruiken cookies om uw ervaring te verbeteren, het verkeer te analyseren en de inhoud te personaliseren. U kunt accepteren of weigeren. Uw voorkeuren worden bewaard.",
      "cookies.accept": "Accepteren",
      "cookies.reject": "Weigeren",
      "cookies.learnMore": "Meer weten",

      // ===== NEWSLETTER =====
      "newsletter.label": "Nieuwsbrief",
      "newsletter.headerCta": "Inschrijven op de nieuwsbrief",
      "newsletter.modalTitle": "Blijf op de hoogte",
      "newsletter.intro": "Schrijf u in om onze nieuwste aanwinsten en exclusieve aanbiedingen te volgen.",
      "newsletter.firstName": "Voornaam",
      "newsletter.email": "Uw e-mail",
      "newsletter.cta": "Inschrijven",
      "newsletter.sending": "Bezig met inschrijven…",
      "newsletter.success": "Inschrijving bevestigd. Dank u!",
      "newsletter.confirmed": "Bedankt! U ontvangt onze volgende updates.",
      "newsletter.error": "Inschrijving mislukt. Controleer uw e-mailadres.",
      "newsletter.disclaimer": "Door in te schrijven aanvaardt u onze communicatie te ontvangen. U kunt zich op elk moment uitschrijven.",

      // ===== INVENTORY =====
      "inventory.eyebrow": "Gecontroleerde selectie",
      "inventory.inventory": "Onze beschikbare wagens",
      "inventory.subtitle": "Elke wagen wordt gecontroleerd, gecertificeerd via Car-Pass en geleverd met 1 jaar garantie inbegrepen.",
      "inventory.resultCount": "wagen(s)",
      "inventory.noVehicles": "Geen wagens beantwoorden aan uw criteria.",
      "inventory.all": "Alle",
      "inventory.available": "Beschikbaar",
      "inventory.reserved": "Gereserveerd",
      "inventory.priceLowHigh": "Prijs: laag naar hoog",
      "inventory.priceHighLow": "Prijs: hoog naar laag",
      "inventory.yearNew": "Bouwjaar: nieuwste eerst",
      "inventory.yearOld": "Bouwjaar: oudste eerst",
      "inventory.mileage": "Oplopende kilometerstand",

      // ===== FILTERS =====
      "filters.title": "Filters",
      "filters.makeModel": "Merk of model",
      "filters.maxPrice": "Max. budget (€)",
      "filters.minYear": "Min. bouwjaar",
      "filters.maxKm": "Max. km",
      "filters.fuel": "Brandstof",
      "filters.status": "Status",
      "filters.all": "Alle",
      "filters.reset": "Filters resetten",

      // ===== COMMON / CARD =====
      "common.available": "Beschikbaar",
      "common.reserved": "Gereserveerd",
      "common.sold": "Verkocht",
      "common.coming_soon": "Binnenkort",
      "common.comingSoon": "Binnenkort beschikbaar",
      "common.featured": "Uitgelicht",
      "card.warranty": "1 jaar garantie",
      "card.details": "Details",
      "card.fromPerMonth": "vanaf € {{amount}}/maand",
      "card.financingLabel": "Financiering mogelijk",
      "coming.headline": "Nieuwe wagen",
      "coming.subline": "In voorbereiding voor u",

      // ===== CAR DETAIL =====
      "car.notFound": "Wagen niet gevonden",
      "car.backToInventory": "Terug naar het aanbod",
      "car.description": "Beschrijving",
      "car.features": "Uitrusting",
      "car.mileage": "Kilometerstand",
      "car.fuel": "Brandstof",
      "car.transmission": "Versnellingsbak",
      "car.color": "Kleur",
      "car.bookToView": "Afspraak maken",
      "car.reserve": "Deze wagen reserveren",
      "car.contactInfo": "Contacteer ons",
      "car.reserveSubject": "Reservering",
      "car.reserveMessage": "Hallo, ik wil deze wagen reserveren:",

      // ===== BOOKING =====
      "booking.title": "Bezoek",
      "booking.appointment": "Afspraak maken",
      "booking.subtitle": "Bezoek uitsluitend op afspraak. We komen binnen 24u op uw vraag terug.",
      "booking.fullName": "Volledige naam",
      "booking.email": "E-mail",
      "booking.phone": "Telefoon",
      "booking.vehicle": "Wagen",
      "booking.selectVehicle": "Selecteer een wagen",
      "booking.preferredDate": "Gewenste datum",
      "booking.preferredTime": "Gewenst uur",
      "booking.selectTime": "Selecteer een uur",
      "booking.pickDate": "Kies een datum",
      "booking.additionalInfo": "Bijkomende informatie",
      "booking.message": "Details, vragen…",
      "booking.note": "Opmerking:",
      "booking.noteText": "Onze garage is uitsluitend toegankelijk op afspraak. U wordt persoonlijk ontvangen, zonder verkoopdruk.",
      "booking.submit": "Mijn aanvraag versturen",
      "booking.submitting": "Versturen…",
      "booking.success": "Aanvraag verstuurd",
      "booking.successToast": "Aanvraag succesvol verstuurd!",
      "booking.successMessage": "We komen binnen 24u terug om uw afspraak te bevestigen.",
      "booking.fillAll": "Gelieve alle vereiste velden in te vullen",
      "booking.error": "Verzenden mislukt. Probeer het opnieuw.",

      // ===== CONTACT =====
      "contact.title": "Contact",
      "contact.touch": "Contacteer ons",
      "contact.subtitle": "Een vraag, een specifiek verzoek? Ons team antwoordt binnen 24 werkuren.",
      "contact.location": "Adres",
      "contact.phone": "Telefoon",
      "contact.email": "E-mail",
      "contact.hours": "Openingsuren",
      "contact.appointmentOnly": "Uitsluitend op afspraak",
      "contact.subject": "Onderwerp",
      "contact.howCanWeHelp": "Hoe kunnen wij u helpen?",
      "contact.yourMessage": "Uw bericht…",
      "contact.sendMessage": "Een bericht sturen",
      "contact.send": "Bericht versturen",
      "contact.sending": "Versturen…",
      "contact.success": "Bericht succesvol verstuurd!",
      "contact.error": "Verzenden mislukt.",
      "contact.fillAll": "Gelieve alle vereiste velden in te vullen",

      // ===== LOCATION =====
      "location.title": "Ons adres",
      "location.address": "Waver, België",
      "location.directions": "Routebeschrijving",

      // ===== SELL PAGE =====
      "sell.eyebrow": "Premium begeleide verkoop",
      "sell.heroTitle": "Verkoop uw wagen",
      "sell.heroTitleAccent": "met hoge standaarden.",
      "sell.heroSubtitle": "Strikte selectie. Professionele presentatie. Veilige verkoop.",
      "sell.cta.primary": "Laat uw wagen schatten",
      "sell.cta.secondary": "Ontdek de dienst",
      "sell.trust1": "Gratis schatting",
      "sell.trust2": "Veilige verkoop",
      "sell.trust3": "Premium standaarden",
      "sell.intro.eyebrow": "Onze aanpak",
      "sell.intro.title": "Wij plaatsen niet zomaar iedere wagen.",
      "sell.intro.p1": "In tegenstelling tot klassieke particuliere platformen wordt elke wagen die AutoDistrict aanbiedt geanalyseerd, gepresenteerd en begeleid volgens onze kwaliteitsstandaarden. Wij begeleiden geselecteerde eigenaars bij de verkoop van hun wagen wanneer die aan onze criteria voldoet.",
      "sell.criteria.eyebrow": "Selectiecriteria",
      "sell.criteria.title": "Elke wagen wordt individueel geselecteerd.",
      "sell.criteria.sub": "Een grondige voorafgaande analyse, omdat kwaliteit boven kwantiteit gaat.",
      "sell.criteria.history": "Duidelijke historiek",
      "sell.criteria.maintenance": "Opgevolgd onderhoud",
      "sell.criteria.config": "Aantrekkelijke configuratie",
      "sell.criteria.condition": "Coherente algemene staat",
      "sell.criteria.profile": "Premium, passie- of goed onderhouden wagen",
      "sell.presentation.eyebrow": "Premium presentatie",
      "sell.presentation.title": "Een ervaring dicht bij de standaarden van premium concessies.",
      "sell.presentation.sub": "Elke wagen krijgt een professionele presentatie die zijn ware potentieel onthult.",
      "sell.offers.photos": "Premium foto's",
      "sell.offers.video": "Presentatievideo",
      "sell.offers.immersive": "Immersieve captatie",
      "sell.offers.dayNight": "Dag- & nachtpresentatie",
      "sell.offers.branding": "AutoDistrict-branding",
      "sell.offers.warranty": "1 jaar garantie inbegrepen*",
      "sell.warranty.disclaimer": "* Garantie van toepassing afhankelijk van de wagen en zijn ontvankelijkheid. Voorwaarden worden geval per geval bevestigd.",
      "sell.handle.title": "Wij regelen alles.",
      "sell.handle.sub": "Van het eerste contact tot de uiteindelijke handdruk — u focust op het resultaat, wij regelen de rest.",
      "sell.handle.listing": "Aanmaak van de advertentie",
      "sell.handle.visibility": "Online zichtbaarheid",
      "sell.handle.requests": "Vragen van kopers",
      "sell.handle.viewings": "Organisatie van bezichtigingen",
      "sell.handle.negotiation": "Onderhandelingen",
      "sell.handle.closing": "Begeleiding tot de verkoop",
      "sell.finalCta.eyebrow": "Klaar om te starten?",
      "sell.finalCta.title": "Laat uw wagen gratis schatten.",
      "sell.finalCta.desc": "Ons team komt binnen 48u op uw aanvraag terug met een persoonlijke analyse.",

      // ===== ESTIMATE =====
      "estimate.eyebrow": "Premium begeleide verkoop",
      "estimate.title": "Laat uw wagen schatten",
      "estimate.subtitle": "Vul onderstaand formulier in. Ons team bekijkt uw dossier en komt snel op uw vraag terug.",
      "estimate.optional": "optioneel",
      "estimate.section.contact": "Uw contactgegevens",
      "estimate.section.vehicle": "De wagen",
      "estimate.section.photos": "Foto's van de wagen",
      "estimate.section.extra": "Bijkomende informatie",
      "estimate.field.firstName": "Voornaam",
      "estimate.field.lastName": "Naam",
      "estimate.field.email": "E-mail",
      "estimate.field.phone": "Telefoon",
      "estimate.field.make": "Merk",
      "estimate.field.model": "Model",
      "estimate.field.year": "Bouwjaar",
      "estimate.field.mileage": "Kilometerstand (km)",
      "estimate.field.fuel": "Brandstof",
      "estimate.field.transmission": "Versnellingsbak",
      "estimate.field.desiredPrice": "Gewenste prijs (€)",
      "estimate.field.ctech": "Geldige technische keuring",
      "estimate.field.carpass": "Car-Pass beschikbaar",
      "estimate.photos.help": "Upload bij voorkeur een foto van elke zijde. JPG/PNG, max 15 MB per foto.",
      "estimate.photo.front": "Voorkant",
      "estimate.photo.back": "Achterkant",
      "estimate.photo.side": "Zijkant",
      "estimate.photo.interior": "Interieur",
      "estimate.extra.placeholder": "Onderhoudshistoriek, uitrusting, bijzonderheden…",
      "estimate.disclaimer": "Door deze aanvraag te versturen aanvaardt u door AutoDistrict gecontacteerd te worden in verband met de schatting van uw wagen. Uw gegevens zijn beschermd — zie ons privacybeleid.",
      "estimate.submit": "Mijn aanvraag versturen",
      "estimate.submitting": "Bezig met versturen…",
      "estimate.success.eyebrow": "Aanvraag verstuurd",
      "estimate.success.title": "Bedankt, wij hebben uw dossier goed ontvangen.",
      "estimate.success.body": "Ons team analyseert uw aanvraag en komt zo snel mogelijk op u terug.",
      "estimate.success.back": "Terug naar de startpagina",
      "estimate.error.notImage": "Het bestand moet een afbeelding zijn",
      "estimate.error.tooBig": "Afbeelding te zwaar (>15 MB)",
      "estimate.error.upload": "Upload mislukt",
      "estimate.error.submit": "Versturen mislukt.",

      // ===== FINANCING =====
      "financing.eyebrow": "Financiering",
      "financing.title": "Bereken uw maandlast",
      "financing.subtitle": "Autolening van € 2.500 tot € 50.000, JKP 5,59 % → 8,99 %, tot 84 maanden.",
      "financing.apr": "JKP",
      "financing.aprRange": "JKP 5,59 % → 8,99 %",
      "financing.duration": "Duur",
      "financing.months": "maanden",
      "financing.years": "jaar",
      "financing.loanAmount": "Geleend bedrag",
      "financing.monthlyPayment": "Geschatte maandelijkse betaling",
      "financing.monthlyRange": "Maandlast (min → max)",
      "financing.totalRepayment": "Totaal terug te betalen",
      "financing.totalRange": "Totaal (min → max)",
      "financing.cost": "Kredietkost",
      "financing.from": "vanaf",
      "financing.perMonth": "per maand",
      "financing.perMonthShort": "/ maand",
      "financing.simulate": "Mijn financiering simuleren",
      "financing.requestQuote": "Offerte aanvragen",
      "financing.requestCta": "Mijn financieringsaanbod aanvragen",
      "financing.requestSubject": "Financieringsaanvraag",
      "financing.requestBody": "Hallo,\n\nIk zou graag een financieringsaanbod ontvangen voor de volgende wagen:\n{{car}}\n\nSimulatie:\n• Te financieren bedrag: € {{amount}}\n• Gewenste duur: {{months}} maanden\n• Indicatieve maandlast: € {{monthlyMin}} → € {{monthlyMax}}\n\nGelieve mij te contacteren om mijn dossier te vervolledigen.",
      "financing.teaser.tooltip": "Indicatieve simulatie — min. JKP 5,59 %, over 60 maanden, zonder voorschot.",
      "financing.warning": "Let op, geld lenen kost ook geld.",
      "financing.notEligibleTitle": "Financiering niet beschikbaar voor deze wagen",
      "financing.notEligibleAgeDesc": "Onze financieringsoplossing is voorbehouden voor voertuigen jonger dan 5 jaar. Neem contact met ons op voor andere financieringsoplossingen.",
      "financing.notEligiblePriceDesc": "Onze financieringsoplossing dekt bedragen tussen € 2.500 en € 50.000. Neem contact met ons op voor een oplossing op maat.",
      "financing.disclaimer": "Indicatieve simulatie van AutoDistrict. Onder voorbehoud van aanvaarding van uw dossier door onze erkende financiële partner. De definitieve JKP is afhankelijk van uw kredietprofiel, het bedrag en de duur. Lening voorbehouden voor tweedehandsvoertuigen ≤ 5 jaar, aangekocht bij een professional.",

      // ===== SEO =====
      "seo.home.title": "AutoDistrict — Gecontroleerde tweedehandswagens in Waver, België",
      "seo.home.desc": "Gesloten garage in Waver. Gecontroleerde tweedehandswagens, Car-Pass, 1 jaar garantie inbegrepen. Aankoop, begeleide verkoop en financiering op maat.",
      "seo.inventory.title": "Aanbod — Tweedehandswagens met garantie",
      "seo.inventory.desc": "Ontdek onze selectie van gecontroleerde tweedehandswagens met 1 jaar garantie. Audi, BMW, Volkswagen en meer. Car-Pass overhandigd voor elke wagen.",
      "seo.sell.title": "Verkoop uw wagen in alle rust",
      "seo.sell.desc": "Begeleide verkoopdienst in Waver: gratis schatting, professionele presentatie, veilige verkoop. Uw wagen in goede handen.",
      "seo.estimate.title": "Laat uw wagen gratis schatten",
      "seo.estimate.desc": "Snel schattingsformulier voor uw wagen. Persoonlijk antwoord binnen 48u. Gratis dienst zonder verbintenis.",
      "seo.booking.title": "Afspraak maken — Bezoek op afspraak",
      "seo.booking.desc": "Reserveer een tijdslot om een wagen bij AutoDistrict te ontdekken. Bezoek uitsluitend op afspraak, persoonlijke begeleiding.",
      "seo.contact.title": "Contact — AutoDistrict Waver",
      "seo.contact.desc": "Contacteer ons team via telefoon, e-mail of het formulier. Antwoord binnen 24 werkuren. Garage in Waver, België.",
      "seo.legal.title": "Wettelijke vermeldingen",
      "seo.legal.desc": "Wettelijke vermeldingen van SHLI SRL — AutoDistrict. Juridische informatie over de uitgever van de site en de hostingprovider.",
      "seo.privacy.title": "Privacybeleid",
      "seo.privacy.desc": "AVG-conform beleid over de bescherming van uw persoonsgegevens. Welke gegevens we verzamelen en hoe we ze gebruiken.",
    },
  },
};

const initialLang = (() => {
  try {
    const stored = typeof window !== 'undefined' ? window.localStorage.getItem('i18nextLng') : null;
    if (stored && ['fr', 'en', 'nl'].includes(stored)) return stored;
    const nav = typeof navigator !== 'undefined' ? (navigator.language || 'fr').split('-')[0] : 'fr';
    return ['fr', 'en', 'nl'].includes(nav) ? nav : 'fr';
  } catch {
    return 'fr';
  }
})();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLang,
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'nl'],
    interpolation: { escapeValue: false },
  });

if (typeof window !== 'undefined') {
  i18n.on('languageChanged', (lng) => {
    try { window.localStorage.setItem('i18nextLng', lng); } catch { /* ignore */ }
  });
}

export default i18n;
